<template>
  <div class="home-wrap">
    <router-view class="home-view"></router-view>
    <nav-bar v-show="showTab" class="nav-tabs" :tabs="tabs"></nav-bar>
  </div>
</template>

<script>
  import NavBar from '../../components/nav-bar';
  export default {
    name: 'home',
    components: {NavBar},
    data () {
      return {
        showTab: false,
        tabs: [
          {
            path: '/home/main',
            icon: 'home',
            title: "首页",
          },
          {
            path: '/home/hall',
            icon: 'hall',
            title: "投注大厅",
          },
          {
            path: '/home/result',
            icon: 'result',
            title: "开奖结果",
          },
          {
            path: '/home/rule',
            icon: 'rule',
            title: "规则说明",
          }
        ]
      }
    },
    mounted() {
    },
    watch: {
      "$route": {
        handler (to, from) {
          this.showTab = to.path === '/home/main';
        },
        immediate: true
      }
    }
  }
</script>
<style scoped lang="less">
  .home-wrap {
    .home-view {
      flex: 1;
      // overflow-x: hidden;
      // overflow-y: auto;
    }
    .nav-tabs{
      flex-shrink: 0;
      background-color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue